export default __webpack_public_path__ + "static/media/Gli amici.29339efb.jpg";